// will work for arrays of energies (factories and batteries). Update CarbonReserveBuilder to follow this format
// accept a starting position, set the offset of each energy based off of the 1st energy
// explode each when "spent", or naw?
// make sure this resets when paymentMode is reset

// todo explode within the payment area? keep track of position to pop

import { useContext, useMemo } from 'react';

import DraggableEnergy from '@/components/game/3d/physics/DraggableEnergy';
import { ViewContext } from '@/state/contexts';
import { getColorfromChar } from '@/util/season';

const EnergyBuilder = ({
	energyArr,
	playerId,
	rotato,
	initPos = [-2, 7, 12.75],
	type = 'factory',
}) => {
	if (energyArr == null || energyArr.length <= 0) return null;

	const { paymentMode }: any = useContext(ViewContext);

	const energyObjects = useMemo(() => {
		const energies: any[] = [];

		for (let i = 0; i < energyArr.length; i++) {
			const energyColor = energyArr[i];
			const color = getColorfromChar(energyColor);
			const homePosition: [number, number, number] = [
				i * 1.5 + initPos[0],
				initPos[1],
				initPos[2],
			];

			energies.push({
				id: `${playerId}-${type}-${energyColor}-${i}-${paymentMode}`,
				color,
				energyColor,
				type,
				homePosition,
			});
		}

		return energies;
	}, [energyArr, paymentMode]);

	const energyDisplay = energyObjects.map((energyObj) => (
		<DraggableEnergy
			key={energyObj.id}
			energy={energyObj}
			rotato={rotato}
		/>
	));

	return (
		<group key={`${type}_energy_group_${playerId}`}>{energyDisplay}</group>
	);
};

export default EnergyBuilder;
